import { CheckboxField as UnstyledCheckboxField, withClassName } from '@epages/react-components'

export default withClassName('ep-form-row-checkbox')(UnstyledCheckboxField)
